import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

export interface AppConfigI {
    apiBffUrl: string;
    bffApiKey: string;
}

export interface AppConfigServiceI {
    apiBffUrl: string;
    bffApiKey: string;
    load: () => Observable<AppConfigI>;
}

@Injectable()
export class AppConfigService implements AppConfigServiceI {
    apiBffUrl = '';
    bffApiKey = '';

    constructor(private readonly http: HttpClient) {}

    public load(): Observable<AppConfigI> {
        return this.http.get<AppConfigI>('./assets/config.json').pipe(
            tap({
                next: (config: AppConfigI) => {
                    this.apiBffUrl = config?.apiBffUrl ?? '';
                    this.bffApiKey = config?.bffApiKey ?? '';
                },
            }),
        );
    }
}

export const initConfig =
    (config: AppConfigService): (() => Observable<AppConfigI>) =>
    () =>
        config.load();
